import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppliedFilter, Filter, FilterConfig } from 'src/app/core/interfaces/filter.interface';
import { TableHeader, TableHeadersMeta, TableQuery } from 'src/app/core/interfaces/table.interface';

@Component({
  selector: 'app-list-layout-v1',
  templateUrl: './list-layout.component.html',
  styleUrl: './list-layout.component.scss'
})
export class ListLayoutComponent implements OnInit {
  @Input({ required: true }) tableHeader: TableHeadersMeta;
  @Input({ required: true }) data: any[];
  @Input({ required: true }) loading: boolean;
  @Input({ required: true }) localKey: string;
  @Input({ required: false }) totalRecords: number;
  @Input({ required: true }) selectStates: 'all' | 'some' | 'none';
  @Input() filterConfigs: FilterConfig[];
  @Input() tenantId?: string;

  @Input() searchPremission?: string;
  @Input() showDateSection: boolean = false;
  @Input() searchPlaceholder: string = 'GENERAL.SEARCH';



  @Output() loadData = new EventEmitter<TableQuery>();
  // TODO: should change this later :)
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onSelectAll = new EventEmitter<boolean>();

  currentOrderBy?: string;
  currentSearch: string = '';

  currentPage = 1;
  pageSize = 10;
  pageSizes = [5, 10, 20, 50, 100];

  appliedFilters: AppliedFilter[] = [];

  loadingPage(input: {
    currentPage: number;
    pageSize: number;
  }) {
    this.currentPage = input.currentPage;
    this.pageSize = input.pageSize;
    this.loadDataHelper();
    // this.savePropsToLocalstroge();

    window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  search(value: string) {
    this.currentSearch = value.trim();
    this.currentPage = 1;

    this.loadDataHelper();
    // this.savePropsToLocalstroge();
  }

  onSort(value: TableHeader) {
    let key = value.key;
    if (typeof key === 'function') {
      key = key();
    }

    if (this.currentOrderBy === key) {
      this.currentOrderBy = undefined;
    } else
      this.currentOrderBy = key;
    this.loadDataHelper();
    // this.savePropsToLocalstroge();
  }

  loadDataHelper() {
    this.loadData.emit({
      currentPage: this.currentPage,
      pageSize: this.pageSize,
      currentOrderBy: this.currentOrderBy,
      currentSearch: this.currentSearch,
      filters: this.appliedFilters,
    });
  }

  updateFilters(filters: AppliedFilter[]) {
    this.appliedFilters = filters;
    this.currentPage = 1;
    this.loadDataHelper();
    // this.savePropsToLocalstroge();
  }

  // savePropsToLocalstroge() {
  //   const tenantId = this.tenantId || '1';
  //   localStorage.setItem(`${tenantId}_${this.localKey}_currentPage`, this.currentPage.toString());
  //   localStorage.setItem(`${tenantId}_${this.localKey}_pageSize`, this.pageSize.toString());

  //   // if (this.appliedFilters) {
  //   //   localStorage.setItem(`${tenantId}_${this.localKey}_currentFilter`, JSON.stringify(this.appliedFilters));
  //   // } else {
  //   //   localStorage.removeItem(`${tenantId}_${this.localKey}_currentFilter`);
  //   // }

  //   if (this.currentOrderBy) {
  //     localStorage.setItem(`${tenantId}_${this.localKey}_currentOrderBy`, this.currentOrderBy);
  //   } else {
  //     localStorage.removeItem(`${tenantId}_${this.localKey}_currentOrderBy`);
  //   }

  //   localStorage.setItem(`${tenantId}_${this.localKey}_currentSearch`, this.currentSearch);
  // }

  getPropsFromLocalstroge() {
    const tenantId = this.tenantId || '1';
    const currentPage = localStorage.getItem(`${tenantId}_${this.localKey}_currentPage`);
    if (currentPage) {
      this.currentPage = parseInt(currentPage);
    }

    const pageSize = localStorage.getItem(`${tenantId}_${this.localKey}_pageSize`);
    if (pageSize) {
      this.pageSize = parseInt(pageSize);
    }

    // const currentFilter = localStorage.getItem(`${tenantId}_${this.localKey}_currentFilter`);
    // if (currentFilter) {
    //   this.appliedFilters = JSON.parse(currentFilter);
    // }

    const currentOrderBy = localStorage.getItem(`${tenantId}_${this.localKey}_currentOrderBy`);
    if (currentOrderBy) {
      this.currentOrderBy = currentOrderBy;
    }

    const currentSearch = localStorage.getItem(`${tenantId}_${this.localKey}_currentSearch`);
    if (currentSearch) {
      this.currentSearch = currentSearch;
    }
  }

  ngOnInit(): void {
    // this.getPropsFromLocalstroge();
    this.loadDataHelper();
  }
}
